
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as TippyTip } from 'react-tippy';
import Tooltip from '@material-ui/core/Tooltip';
import 'react-tippy/dist/tippy.css';
import { withStyles } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from 'react-device-detect';

const styles = (theme) => ({
  tooltip: {
    fontSize: theme.typography.caption.fontSize,
    background: 'rgba(0,0,0,.75)',
    color: 'white',
  },
});

class QTip extends React.Component {

  constructor(props) {
    super(props);
    this.wrapRef = null;
    this.state = {
      id: props.wrapId || uuidv4(),
      overflow: false,
    };
  }

  componentDidMount() {
    if (this.props.wrapOnly) {
      this.checkOverflow();
    }
  }

  componentWillReceiveProps(nextProps) {

    this.wrapRef = null;
    if (nextProps.wrapOnly) {
      this.setState({ overflow: false });
      this.checkOverflow();
    }
    if (nextProps.wrapId !== this.props.wrapId) {
      this.setState({ id: nextProps.wrapId });
    }
  }

  isElementOverflow = (element) =>
    element && (element.clientWidth < element.scrollWidth);

  checkOverflow = () => {

    let element = this.wrapRef || document.getElementById(`QtipId:${this.state.id}`);
    this.wrapRef = element;

    if (element && element.children) {
      element = element.firstElementChild;
    }

    const overflow = this.isElementOverflow(element);
    this.setState({ overflow });
  };

  render() {
    const { children, title, html, classes, className, wrapId, wrapOnly, ...other } = this.props;

    if (!isMobile && ((html || (typeof title === 'string' && title.trim().length > 0)) && (!this.props.wrapOnly || this.state.overflow))) {
      return (
        html ?
          (<TippyTip
            animation="fade"
            id={`tooltip-id:${this.state.id}`}
            theme="transparent"
            hideOnClick
            size="small"
            duration={200}
            distance={15}
            position={this.props.placement || "bottom-end"}
            title={html ? null : (title || '')}
            html={html}
            delay={500}
            // style={{ width: 'inherit', height: 'inherit' }}  // this line breaks ie-11
            {...other}
          >
            <span style={{ height: '100%' }} id={`QtipId:${this.state.id}`} className={className}>
              {children}
            </span>
          </TippyTip>)
          :
          (<Tooltip
            enterDelay={500}
            id={`tooltip:${this.state.id}`}
            leaveDelay={200}
            placement={this.props.position || "bottom-end"}
            title={title || ''}
            classes={{ tooltip: classes.tooltip}}
            {...other}
          >
            <span id={`QtipId:${this.state.id}`} className={className}>
              {children}
            </span>
          </Tooltip>)
      );
    }
    return (
      <span id={`QtipId:${this.state.id}`} className={className}>
        {children}
      </span>
    );
  }
}

QTip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  html: PropTypes.object,
  wrapOnly: PropTypes.bool,
  wrapId: PropTypes.string,
  classes: PropTypes.object,
  enterDelay: PropTypes.number,
  placement: PropTypes.string,
  position: PropTypes.string, // accepts either one of these as an override
};

export default withStyles(styles)(QTip);
